import { render, staticRenderFns } from "./TradeURLModal.vue?vue&type=template&id=f7d24112&scoped=true&"
import script from "./TradeURLModal.vue?vue&type=script&lang=js&"
export * from "./TradeURLModal.vue?vue&type=script&lang=js&"
import style0 from "./TradeURLModal.vue?vue&type=style&index=0&id=f7d24112&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d24112",
  null
  
)

export default component.exports